import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import AppLoader from "@/components/AppLoader";

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <AppLoader />;
  }

  if (!user) return <Navigate to="/login" replace />;

  return <>{children}</>;
}
